import React from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import SubregionList from '../SubregionList';
import HeaderBar from './HeaderBar';
import ApplyToShipperBar from './ApplyToShipperBar';

const SubregionsColumn = ({
    deliveryProfileId,
    deliveryProfiles,
    onSelectProfile,
    onCreateProfile,
    onEditProfile,
    state,
    loading,
    callbacks,
}) => (
    <Grid
        container
        direction="column"
        css={css`
            flex: 0;
            flex-basis: 0;
            flex-wrap: nowrap;
            min-width: 400px;
            border-right: 1px solid ${colors.greys[0]};
        `}
    >
        <HeaderBar
            deliveryProfileId={deliveryProfileId}
            deliveryProfiles={deliveryProfiles}
            onSelect={onSelectProfile}
            onCreate={onCreateProfile}
            onEdit={onEditProfile}
        />
        {deliveryProfileId ? (
            <ApplyToShipperBar
                shippers={state.shippers}
                deliveryProfileId={deliveryProfileId}
                deliveryProfile={state.deliveryProfile}
                assignmentsByShipper={state.assignmentsByShipper}
                applyToShipper={callbacks.applyToShipper}
                onSuccess={() =>
                    callbacks.setNotification({ severity: 'success', message: 'Profile applied to shipper' })
                }
            />
        ) : null}
        <SubregionList
            options={{
                enableAddSubregions: !!deliveryProfileId,
                enableImport: !!deliveryProfileId,
                enableExport: !!deliveryProfileId,
            }}
            loading={loading}
            filter={state.filter}
            highlightOverride={state.highlightOverride}
            selected={state.selectedSubregion}
            subregions={state.subregions}
            callbacks={callbacks}
        />
    </Grid>
);

export default SubregionsColumn;
